import React from "react";
// import "./HelpNearYou.css";
import "./HelpNearYou1.css";

const HelpNearYouPara = () => {
  return (
    <div className="helpNearYouParaContainer">
      <p>
         SCENT is your trusted neighborhood destination. Experience safety
        and quality at any of our 6 outlets conveniently located
        across Bengaluru.
      </p>
    </div>
  );
};

export default HelpNearYouPara;
